import * as React from 'react';
import { RegisterOptions, UseFormReturn } from 'react-hook-form';
import { Input } from '../../../components/forms/Input';
import { SquareButtonIconsEnum } from '../../../constants/square-button-icons';
import { Void } from '../../../models/basic-objects';
import { FormModal } from '../../../components/containers/FormModal';
import { InputTypes } from '../../../constants/form';
import { ValidationMessages } from '../../../constants/validation-messages';
import { useUserData } from '../../../hooks/useUserData';

export type PasswordModalViewProps = {
  hasCurrentPassword: boolean;
  onClose: () => void;
  onSubmitChangePassword: (data: { newPassword: string; oldPassword: string }) => void;
  submitted: boolean;
  passwordRules: RegisterOptions;
  currentPasswordButtonState: SquareButtonIconsEnum.show | SquareButtonIconsEnum.hide;
  newPasswordButtonState: SquareButtonIconsEnum.show | SquareButtonIconsEnum.hide;
  confirmPasswordButtonState: SquareButtonIconsEnum.show | SquareButtonIconsEnum.hide;
  currentShowToggle: Void;
  newPasswordShowToggle: Void;
  confirmPasswordShowToggle: Void;
  useFormInstance: UseFormReturn;
  onSubmitSetPassword: (data: { newPassword: string }) => void;
};

export const PasswordModalView = (props: PasswordModalViewProps): JSX.Element => {
  const { userData } = useUserData();
  const isPasswordSet = !!userData?.passwordSet;
  const validatePassword = (confirmPassword: string) => {
    return props.useFormInstance.getValues('newPassword') === confirmPassword || 'Passwords do not match';
  };
  return (
    <FormModal
      onClose={props.onClose}
      showCloseIcon={props.submitted}
      formInstance={props.useFormInstance}
      loading={props.submitted}
      onSubmit={isPasswordSet ? props.onSubmitChangePassword : props.onSubmitSetPassword}
      submitText={'Save Password'}
      title={'Change Password'}>
      <div className={`padding-top-small-4 padding-bottom-small-16`}>
        {isPasswordSet && (
          <Input
            action={props.currentShowToggle}
            actionButton={{ icon: props.currentPasswordButtonState }}
            disabled={props.submitted}
            formInstance={props.useFormInstance}
            name={'oldPassword'}
            type={
              props.currentPasswordButtonState === SquareButtonIconsEnum.show ? InputTypes.password : InputTypes.text
            }
            size={'large'}
            label={'Current Password'}
            rules={{ required: ValidationMessages.password.required }}
          />
        )}
      </div>
      <div className={`padding-bottom-small-16`}>
        <Input
          action={props.newPasswordShowToggle}
          actionButton={{ icon: props.newPasswordButtonState }}
          disabled={props.submitted}
          formInstance={props.useFormInstance}
          name={'newPassword'}
          type={props.newPasswordButtonState === SquareButtonIconsEnum.show ? InputTypes.password : InputTypes.text}
          size={'large'}
          label={'New Password'}
          rules={props.passwordRules}
          helper={'This password must be at least 8 characters long'}
        />
      </div>
      <div className={`padding-bottom-small-4`}>
        <Input
          action={props.confirmPasswordShowToggle}
          actionButton={{ icon: props.confirmPasswordButtonState }}
          disabled={props.submitted}
          formInstance={props.useFormInstance}
          name={'confirmPassword'}
          type={props.confirmPasswordButtonState === SquareButtonIconsEnum.show ? InputTypes.password : InputTypes.text}
          size={'large'}
          label={'Confirm New Password'}
          rules={{ ...props.passwordRules, validate: validatePassword }}
        />
      </div>
    </FormModal>
  );
};
